import { useEffect, useState } from "react";
import { UserPlus, UserCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function FollowButton({ userId, initialFollowing = false, onChange, className = "" }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [following, setFollowing] = useState(initialFollowing);
    const [busy, setBusy] = useState(false);

    useEffect(() => { setFollowing(initialFollowing); }, [initialFollowing]);

    if (user && user.id === userId) return null;

    async function toggle(e) {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        if (!user) {
            toast.error("Sign in to follow witnesses");
            navigate("/login");
            return;
        }
        if (busy) return;
        setBusy(true);
        try {
            const { data } = following
                ? await api.delete(`/social/users/${userId}/follow`)
                : await api.post(`/social/users/${userId}/follow`);
            setFollowing(data.following);
            onChange?.(data.following, data.follower_count);
        } catch {
            toast.error("Could not update follow");
        } finally {
            setBusy(false);
        }
    }

    return (
        <button
            onClick={toggle}
            disabled={busy}
            className={`${following ? "ok-btn-primary" : "ok-btn-outline"} text-xs inline-flex items-center gap-1 ${className}`}
            data-testid={`follow-btn-${userId}`}
        >
            {following ? <UserCheck className="w-3 h-3" /> : <UserPlus className="w-3 h-3" />}
            {following ? "Following" : "Follow"}
        </button>
    );
}
